<template>
    <!--todo 活動頁地圖-->
    <div class="MapList">
        <category-header title="友善地圖" class="mb-2" v-show="isShowImageMap(shoppingActMap)"/>
        <div class="container mb-4" v-show="isShowImageMap(shoppingActMap)">
            <img :src="shoppingActMap.mapImageUrl" class="radius-pic">
        </div>

        <!--todo 嵌入google map-->
        <category-header title="Google Map" class="mb-2" v-show="isShowGoogleMap(shoppingActMap)"/>
        <div class="map-container" v-html="shoppingActMap.googleMapUrl" v-show="isShowGoogleMap(shoppingActMap)"/>

        <category-header title="說明" class="mb-2" v-show="isShowGeographic(shoppingActMap)"/>
        <div class="container" v-show="isShowGeographic(shoppingActMap)">
            <div class="text-content mb-4">
                <div v-html="shoppingActMap.geographicNote"/>
            </div>
        </div>

    </div>
</template>

<script>
    import CategoryHeader from '@/components/category/Header'
    export default {
        name: "MapActivity",
        components: {
            CategoryHeader,
        },
        props: {
            outerActMap: { default: undefined },  // 外層傳來的 shoppingActMap
        },
        watch: {
            //監聽，等到資料有變動再開始動作
            outerActMap: function () {
                if (this.outerActMap !== undefined) {
                    this.shoppingActMap = this.outerActMap;
                }
            },
        },
        data() {
            return {
                shopAreaId: Number(this.$store.state.shopAreaInfo.id),   //商圈 id
                shoppingActMap: {},
                //google map嵌入碼
                // mapUrl:'<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7365.157655585114!2d120.28875454350852!3d22.632197668601563!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e04668fb2f26d%3A0x65960019b5b54ee9!2z5ZGz5rSl5o6S6aqo5aSn546L!5e0!3m2!1szh-TW!2stw!4v1637635890782!5m2!1szh-TW!2stw" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>',
                mapUrl:'<iframe src="" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>',
            }
        },
        created() {

        },
        mounted() {

        },
        methods: {

            /** 是否顯示友善地圖 */
            isShowImageMap: function(info) {
                return (this.$public.notNull(info.mapImageUrl) && info.mapImageUrl !== '') ;
            },


            /** 是否顯示位置資訊 */
            isShowGeographic: function(info) {
                return (this.$public.notNull(info.geographicNote) && info.geographicNote !== '') ;
            },

            /** 是否顯示 GoogleMap */
            isShowGoogleMap: function(info) {
                return (this.$public.notNull(info.googleMapUrl) && info.googleMapUrl !== '') ;
            },

        }
    }
</script>
